import { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Input, TextArea, Select, TextAreaAdvanced, InputSearch } from "../../../Layout/Forms/Form";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EventTablesRequest from './EventTablesRequest';

const FormTableReservationInfo = ({ show, handleModalhide, info }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            price: '',
            phone_number: '',
            owner_name: '',
            observations_public: '',
            observations_private: '',
        },
        errors: [],
    });
    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }

    const handleCheckOutTable = async () => {
        setIsLoading(true);
        let request = await EventTablesRequest.checkOutTable({ id_events: info.table.id_events, id: info.table.id, });
        if (request) {
            if (request.status) {
                toast.success("Checkout concluido com sucesso.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                handleModalhide();
            } else {
                toast.error(request.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        }
        setIsLoading(false);
    }

    const handleCancelTable = async () => {
        setIsLoading(true);
        let request = await EventTablesRequest.cancelTable({ id_events: info.table.id_events, id: info.table.id, });
        if (request) {
            if (request.status) {
                toast.success("Cancelamento concluido com sucesso.", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
                handleModalhide();
            } else {
                toast.error(request.error, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "dark",
                });
            }
        }
        setIsLoading(false);
    }




    return (

        <>
            <Modal show={show} onHide={handleModalhide}>
                <Modal.Header closeButton>
                    <Modal.Title>Info mesa</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ height: '75vh' }}>
                    {!show ? null : <>
                        <div className="row">
                            <div className="col-6">
                                <label className="form-label">Mesa</label>
                                <input type="text" className="form-control" value={info.table.name} disabled readOnly />

                            </div>
                            <div className="col-3">
                                <label className="form-label">Capacidade</label>
                                <input type="text" className="form-control text-center" value={info.table.numberOfGuests} disabled readOnly />
                            </div>
                            <div className="col-3">
                                <label className="form-label">Preço</label>
                                <input type="text" className="form-control text-end" value={info.table.base_price_formated} disabled readOnly />
                            </div>
                        </div>
                        <div className='row mt-5'>
                            <div className='col-12'>
                                <div className='p-3' style={{ backgroundColor: '#0d1012' }}>
                                    <div className='row'>
                                        <div className='col-3'>
                                            {
                                                info.table.reservation_owner_photo ?
                                                    <img style={{ height: '75px', width: '75px', border: '3px solid #3e3e3e' }} src={info.table.reservation_owner_photo} className='rounded-circle' />
                                                    :
                                                    <div className='rounded-circle' style={{ height: '75px', width: '75px', border: '3px solid #3e3e3e', backgroundColor: '#ea2c61' }}></div>
                                            }

                                        </div>
                                        <div className='col-9'>
                                            <div className='row'>
                                                <div className='col-12'>
                                                    {info.table.reservation_owner}
                                                </div>
                                            </div>
                                            <div className='row mt-5'>
                                                <div className='col-6'>
                                                    <a className='link-light' href={`tel:${info.table.reservation_owner_phone_number}`}><i className="fa-solid fa-phone me-3"></i>{info.table.reservation_owner_phone_number}</a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mt-5'>
                            <div className='col-6'>
                                <button className='btn btn-dark btn-lg w-100' onClick={() => handleCheckOutTable()}>
                                    <div><i className="fa-solid fa-right-from-bracket"></i></div>
                                    Check-out
                                </button>
                            </div>
                            <div className='col-6'>
                                <button className='btn btn-dark btn-lg w-100' onClick={() => handleCancelTable()}>
                                    <div><i className="fa-solid fa-lock-open"></i></div>
                                    Libertar mesa
                                </button>
                            </div>
                        </div>


                    </>}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalhide}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer /> */}
        </>
    );
}

export default FormTableReservationInfo;